import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  @media (min-width: 1280px) {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const StoreContainer = styled.button`
  display: flex;
  // justify-content: space-between;
  align-items: center;
  background: white;
  //   width: 119px;
  height: 32px;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;

  p {
    font-size: 14px;
    margin-left: 6px;
  }
  .space-right {
    margin-right: 5px;
  }

  &:hover {
    background: #d5e5f0;
    cursor: pointer;
  }

  &:focus {
    background: #a8cbe2;
  }
  &:active {
    background: #a8cbe2;
  }

  @media (min-width: 640px) and (max-width: 991px) {
    margin-left: 24px;
  }
  @media (min-width: 992px) {
    margin: 0px auto 0px 0px;
  }

  @media (min-width: 1280px) {
    margin: 0px 16px 0px 0px;
  }
`;

const StoreRow = styled.div`
  @media (min-width: 992px) {
    display: flex;
    // margin-left: 0px;
    // margin-right: 0px;
  }
`;

const Title = styled.p`
  font-size: 18px;
  line-height: 28px;
  font-weight: 900;
  color: #161d1f;
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  @media (min-width: 640px) and (max-width: 991px) {
    margin-left: 24px;
    justify-content: flex-start;
  }
  @media (min-width: 992px) {
    display: flex;
    justify-content: flex-start;
  }
`;

const ListItem = styled.li`
  display: flex;
  justify-content: center;
  height: 36px;
  margin-top: 20px;
  @media (min-width: 640px) and (max-width: 991px) {
    margin-left: 24px;
    justify-content: flex-start;
  }
  @media (min-width: 992px) {
    display: flex;
    justify-content: flex-start;
  }
`;

const LinkContainer = styled.button`
  display: flex;
  padding-right: 10px;

  & p {
    &:hover {
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      color: #4f6168;
    }
  }

  &:focus {
    border: 1px solid #161d1f;
    border-radius: 4px;
  }
  &:active {
    border: 1px solid #161d1f;
    border-radius: 4px;
  }
`;

const Text = styled.p`
  color: #161d1f;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid;
  margin: 6px 0px 5px 10px;
`;

const FooterContainer = styled.div`
  width: 100%;
  padding-top: 24px;
`;

const FooterColumn = styled.div`
  border-top: 1px solid #a8cbe280;
  margin: 10px 0px 10px 0px;
  padding: 15px 0px;

  @media (min-width: 640px) {
    border-top: 0px;
    padding: 0px;
    margin: 0px;
  }

  @media (min-width: 992px) {
    width: 205px;
  }

  @media (min-width: 1280px) {
    width: 100%;
  }
`;

const ChannelUtp = styled.button`
  background: White;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  height: 52px;

  &:hover {
    background: #d5e5f0;
    cursor: pointer;
  }
  &:focus {
    background: #a8cbe2;
  }
  &:active: {
    background: #a8cbe2;
  }
`;

const UtpInfo = styled.span`
  margin-left: 7px;
`;
const ChannelWhatsapp = styled.button`
  display: flex;
  align-items: center;
  border: 1px solid #226c37;
  height: 52px;
  padding: 4px 8px;
  border-radius: 4px;
  //margin-top: 18px;

  img:hover {
    color: #2d8746;
  }

  img:focus {
    color: #175128;
  }

  &:hover {
    background: #a8f1bb;
  }

  &:focus {
    background: #e8f6ec;
  }

  &:active {
    background: #e8f6ec;
  }
`;

const WhatsappInfo = styled.span`
  margin-left: 7px;
  color: #226c37;
`;

const InfoChannel = styled.div`
  font-weight: 700;
  font-size: 16px;
  display: flex;
  justify-content: flex-start;
`;

const LineSeparatorTop = styled.hr`
  color: #a8cbe2;
  margin-top: 56px;
`;

const LineSeparatorBot = styled.hr`
  color: #a8cbe2;
  margin-top: 20px;
  @media (min-width: 361px) {
    margin-top: 50px;
  }
  @media (min-width: 640px) {
    margin-top: 70px;
  }
  @media (min-width: 992px) {
    margin-top: 40px;
  }
`;

const AllRightsReserved = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  color: #161d1f;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: 313px;
  @media (min-width: 361px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }
`;

export {
  Container,
  StoreContainer,
  StoreRow,
  Title,
  Text,
  ChannelUtp,
  UtpInfo,
  ChannelWhatsapp,
  WhatsappInfo,
  InfoChannel,
  ListItem,
  LinkContainer,
  FooterContainer,
  FooterColumn,
  LineSeparatorTop,
  LineSeparatorBot,
  AllRightsReserved
};
